export default "__VITE_ASSET__W89Xt7_I__"